<template>
  <v-flex xs12 class="expiry-banner" v-show="bannerState">
    <v-card color="white">
      <v-layout>
        <v-flex xs1 class="warning-sign-banner">
        <v-icon class="warning-icon-banner">warning</v-icon>
        </v-flex>
        <v-flex xs10>
          <v-card-title primary-title class="msg-banner">
            <div>
              <div class="title font-weight-medium subscription-alert" ><slot name="header"></slot></div>
              <div class="subheading subscription-msg"><slot></slot></div>
            </div>
          </v-card-title>
        </v-flex>
        <v-flex xs1 class="close-sign-banner">
          <v-icon @click="closeBannerHandler" class="close-icon-banner">highlight_off</v-icon>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    isBannerOpen: {
      type: Boolean,
      default: true 
    },
  },
  data () {
    return {
      bannerState: true
    }
  },
  mounted() {
    this.bannerState = this.isBannerOpen
  },
  methods: {
    closeBannerHandler() {
      this.bannerState = false
      this.$emit('toggleBanner', this.bannerState)
    }
  },
  watch: {
    isBannerOpen(val) {
      this.bannerState = val
    }
  }
}
</script>

<style scoped>
 
.subscription-alert{
  color: #cc5356;
}
.subscription-msg{
  color: #cc5356;
}
.warning-sign-banner{
  padding: 8px;
  background-color: #cc5356;
  text-align: center;
}
.warning-icon-banner{
  font-size: 40px;
}
.msg-banner{
  padding: 8px 0px 0px 8px;
}
.close-sign-banner{
  padding: 10px 10px 10px 10px;
  text-align: center;
}
.close-icon-banner{
  color: #cc5356;
}
  .first-link{
    color: #534b00 !important;
    text-decoration-line: underline;
  }
  
  .second-link{
    color: #485bff;
    cursor: pointer;
  }
</style>